var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHokey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 28.8L6.41271 36H3.80838C2.55732 36 1.5609 34.6756 2.19822 33.395L3.99821 29.795C4.30407 29.185 4.92656 28.8 5.60837 28.8H10.0004ZM32.6083 0.000192856H30.8083C30.126 0.000192856 29.504 0.385153 29.1981 0.995138L15.2958 28.7998H12.0127L8.42529 35.9998H16.4082C17.0905 35.9998 17.7125 35.6148 18.0181 35.0049L34.2181 2.60504C34.8664 1.30326 33.8195 0 32.6082 0L32.6083 0.000192856ZM23.6083 36H34.4083V30.6H23.6083V36Z",
    fill: "#155934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokey);
export default __webpack_public_path__ + "static/media/hokey.b0164eb8.svg";
export { ForwardRef as ReactComponent };